/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var preloader = function preloader(dom, display) {
    if (display) {
        dom.find('.preloader').removeClass('hidden');
    } else {
        dom.find('.preloader').addClass('hidden');
    }
};

/* harmony default export */ __webpack_exports__["a"] = (preloader);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preloader__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["a"] = displayFormError;


function displayFormError(form, responseError) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);

    var alert = form.find('.danger-alert');

    alert.removeClass('d-none');

    alert.html('');

    var response = responseError !== undefined ? responseError.responseJSON : undefined;
    var errors = response !== undefined && response !== null ? response.errors : undefined;
    var printed = false;

    if (errors !== undefined && errors !== null && errors !== false) {
        for (var error in errors) {
            if (!errors.hasOwnProperty(error)) {
                continue;
            }

            var message = Array.isArray(errors[error]) ? errors[error].join('<br>') : errors[error];

            alert.append(message + '<br>');

            printed = true;
        }
    }

    // non-json / unexpected answer (500, 419, network drop): still tell the user something
    if (!printed) {
        var fallback = alert.data('fallback');

        if (response !== undefined && response !== null && response.message) {
            fallback = response.message;
        }

        alert.append(fallback ? fallback : 'Error. Please try again.');
    }
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preloader__ = __webpack_require__(0);
/* harmony export (immutable) */ __webpack_exports__["b"] = tableActions;


var members = function members(container, queryOnDocumentLoad) {
    var elements = $('.' + container);

    if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
            tableActions($(elements[i]), queryOnDocumentLoad);
        }
    }
};

function tableActions(dom, queryOnDocumentLoad, sectionID) {
    var timer = void 0;
    var duration = 300;
    var sort = 'default';
    var page = 1;
    var canScrollToStartTable = false;
    var onlySectionID = sectionID === undefined ? 0 : sectionID;

    if (queryOnDocumentLoad) {
        query(dom);
    }

    // Sort action
    dom.find('.sort-table').on('click', function () {
        $(this).toggleClass('active');
        sort = $(this).hasClass('active') ? 'asc' : 'default';
        canScrollToStartTable = false;
        query(dom);
    });

    // Filter action
    var filterForm = dom.find('.members-filter-form');

    filterForm.find('input').on('keyup change', function (e) {
        if (e.which !== undefined && e.which !== 13) {
            page = 1;
            canScrollToStartTable = false;
            enableDisableButtonReset(dom);
            query(dom);
        }
    });

    filterForm.find('select').on('change', function () {
        page = 1;
        canScrollToStartTable = false;
        enableDisableButtonReset(dom);
        query(dom);
    });

    filterForm.on('submit', function (event) {
        event.preventDefault();
    });

    // Reset action
    dom.find('.members-filter-reset').on('click', function () {
        filterForm.trigger('reset');
        enableDisableButtonReset(dom);
        canScrollToStartTable = false;
        query(dom);
    });

    // Enable/Disable button reset
    function enableDisableButtonReset(dom) {
        var button = dom.find('.members-filter-reset');
        var data = dom.find('.members-filter-form').serializeArray().filter(function (item) {
            return item.value && item.value !== '0' && item.name !== 'limit' && item.name !== 'displaySection' && item.name !== 'type';
        });

        if (data.length) {
            button.removeClass('d-none');
        } else {
            button.addClass('d-none');
        }
    }

    function initPagination(dom) {
        // Pagination action
        dom.find('.pagination a').on('click', function () {
            event.preventDefault();
            page = $(this).attr('href').split('page=')[1];
            canScrollToStartTable = true;
            query(dom);
        });
    }

    // Filter by section tab
    $(document).on('click', '.item-section', function (e) {
        e.preventDefault();

        onlySectionID = $(this).data('id');
        page = 1;

        dom.removeClass('d-none');

        // Insert section detail in table
        dom.find('.name-section').html($(this).data('title'));
        dom.find('.additional-info').html('<span class="author-position">' + $(this).data('subtitle') + '</span>');

        canScrollToStartTable = false;

        // Scroll to start table
        $('html, body').animate({
            scrollTop: dom.find('.table').offset().top - 300
        }, 300);

        // Query result
        query(dom);
    });

    // Query result
    function query(dom) {
        var domItems = dom.find('.members-items');

        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(dom, true);

            $.ajax({
                url: '/' + window.Laravel.language + '/modules/members',
                dataType: 'json',
                type: 'get',
                data: dom.find('.members-filter-form').serialize() + '&page=' + page + '&sort=' + sort + (onlySectionID ? '&section=' + onlySectionID : ''),
                success: function success(response) {
                    domItems.html(response.view);

                    initPagination(dom);

                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(dom, false);

                    if (canScrollToStartTable) {
                        // Scroll to start table
                        $('html, body').animate({
                            scrollTop: dom.find('.table').offset().top - 300
                        }, 300);
                    }
                },
                error: function error(jqXhr, textStatus, errorThrown) {
                    alert(errorThrown);
                }
            });
        }, duration);
    }
}

/* harmony default export */ __webpack_exports__["a"] = (members);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_membersWorks__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functions_heroModules__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functions_register__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__functions_share__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_members__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__functions_sections__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__functions_forms__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__functions_profile__ = __webpack_require__(9);
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */



// require('./bootstrap');

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

/**
 * Include the FrontEnd index.js file
 */

__webpack_require__(7);







// import gallery from './functions/gallery'

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__functions_register__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__functions_share__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__functions_members__["a" /* default */])('members-section', true);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__functions_sections__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__functions_forms__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__functions_profile__["a" /* default */])();
// gallery();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__functions_membersWorks__["a" /* default */])();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__functions_heroModules__["a" /* default */])();

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preloader__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(1);



var forms = function forms() {
    // Feedback form

    $('.feedback-form').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        // in-flight guard: a double click must not send two identical emails
        if (form.data('submitting')) {
            return;
        }

        form.data('submitting', true);

        var buttons = form.find('button[type="submit"]');

        buttons.prop('disabled', true);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: form.serialize(),
            success: function success(response) {
                // the server answers 2xx only when the message was really sent
                form.trigger('reset');

                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);

                form.find('.success-alert').removeClass('d-none');
            },
            error: function error(responseError) {
                // keep whatever the user typed, just show the error
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* displayFormError */])(form, responseError);
            },
            complete: function complete() {
                form.data('submitting', false);

                buttons.prop('disabled', false);
            }
        });
    });
};

/* harmony default export */ __webpack_exports__["a"] = (forms);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = heroModules;
/**
 * Behaviour for the hero page-builder modules.
 *
 * Three rules this file exists to enforce, all learned from the modules it sits beside:
 *
 * 1. Every instance is initialised independently from its own data- attributes. Nothing is
 *    stored globally and nothing selects across the whole document, so two heroes on one page
 *    can't interfere with each other. (The older PhotoSlideshow hands a multi-element selector
 *    to Swiper, which returns an *array*, and the `.on()` call that follows throws — inside an
 *    untry/caught boot sequence, which leaves the whole site stuck behind the preloader.)
 * 2. Every init is wrapped, so one broken hero can't take down the others or the page.
 * 3. The markup is already correct before this file runs — slide 1 carries `is-active` from
 *    the server. JS only ever *changes* the active slide, it never has to establish one. With
 *    JS disabled or broken the hero is a static, readable image.
 */

var REDUCED_MOTION = function REDUCED_MOTION() {
    return typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

/**
 * Run an initialiser for each matching element without letting a failure escape.
 */
function each(selector, fn) {
    var nodes = document.querySelectorAll(selector);

    for (var i = 0; i < nodes.length; i++) {
        try {
            fn(nodes[i]);
        } catch (e) {
            // Deliberately swallowed: a broken hero must not stop the rest of the page
            // booting. Logged so it's still discoverable in the console.
            if (window.console && console.warn) {
                console.warn('[hero] init failed for', selector, e);
            }
        }
    }
}

/**
 * Shared crossfade carousel. Both hero slideshows are the same machine with different
 * chrome, so they share this and pass in which extras they have.
 */
function carousel(root, opts) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    var texts = root.querySelectorAll('[data-hero-text]');
    var goButtons = root.querySelectorAll('[data-hero-go]');
    var total = slides.length;

    if (total === 0) {
        return;
    }

    var delay = Math.max(1000, parseInt(root.getAttribute('data-autoplay'), 10) || opts.defaultDelay);

    var current = 0;
    var timer = null;
    var paused = false;

    function setActive(nodes, index) {
        for (var i = 0; i < nodes.length; i++) {
            var on = i === index;
            nodes[i].classList.toggle('is-active', on);
            // Keep AT in step with what's visually shown.
            if (on) {
                nodes[i].removeAttribute('aria-hidden');
            } else {
                nodes[i].setAttribute('aria-hidden', 'true');
            }
        }
    }

    function paintControls(index) {
        for (var i = 0; i < goButtons.length; i++) {
            goButtons[i].classList.toggle('is-current', i === index);
            goButtons[i].classList.toggle('is-past', i < index);
        }

        // Restart the progress animation on the bar that just became current. Clearing the
        // animation and forcing a reflow is the only reliable way to replay a CSS animation.
        var fill = goButtons[index] ? goButtons[index].querySelector('.hero-slideshow__bar-fill') : null;
        if (fill) {
            fill.style.animation = 'none';
            void fill.offsetWidth;
            fill.style.animation = '';
        }

        // A module with a single continuous bar (no per-slide go-buttons) marks it with
        // data-hero-progress-fill directly on the root instead of nesting it in a go-button.
        // No-op for modules that don't have one.
        //
        // Resets animation-name specifically, not the animation shorthand: the shorthand
        // resets every sub-property it covers (including animation-duration) to its CSS
        // initial value, which would silently wipe the inline animation-duration this
        // element gets from the server (the autoplay-derived timing) down to 0s the first
        // time this runs.
        var progressFill = root.querySelector('[data-hero-progress-fill]');
        if (progressFill) {
            progressFill.style.animationName = 'none';
            void progressFill.offsetWidth;
            progressFill.style.animationName = '';
        }
    }

    function go(index) {
        current = (index % total + total) % total;
        setActive(slides, current);
        setActive(texts, current);
        paintControls(current);
    }

    function stop() {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
    }

    function schedule() {
        stop();

        // Reduced motion, a single slide, or a paused hero: never auto-advance. Manual
        // controls keep working in all three cases.
        if (paused || total < 2 || REDUCED_MOTION()) {
            return;
        }

        timer = setTimeout(function () {
            go(current + 1);
            schedule();
        }, delay);
    }

    function setPaused(state) {
        paused = state;
        root.classList.toggle('is-paused', state);
        schedule();
    }

    for (var i = 0; i < goButtons.length; i++) {
        goButtons[i].addEventListener('click', function () {
            go(parseInt(this.getAttribute('data-hero-go'), 10) || 0);
            schedule();
        });
    }

    var prev = root.querySelector('[data-hero-prev]');
    if (prev) {
        prev.addEventListener('click', function () {
            go(current - 1);
            schedule();
        });
    }

    var next = root.querySelector('[data-hero-next]');
    if (next) {
        next.addEventListener('click', function () {
            go(current + 1);
            schedule();
        });
    }

    // Pause on hover per the design, and on keyboard focus too — hover alone is a mouse-only
    // affordance and leaves keyboard users unable to stop the motion.
    root.addEventListener('mouseenter', function () {
        return setPaused(true);
    });
    root.addEventListener('mouseleave', function () {
        return setPaused(false);
    });
    root.addEventListener('focusin', function () {
        return setPaused(true);
    });
    root.addEventListener('focusout', function () {
        return setPaused(false);
    });

    // Don't animate a hero nobody is looking at.
    document.addEventListener('visibilitychange', function () {
        if (document.hidden) {
            stop();
        } else {
            schedule();
        }
    });

    paintControls(0);
    schedule();
}

function heroModules() {
    each('[data-hero-slideshow]', function (root) {
        return carousel(root, { defaultDelay: 5000 });
    });
    each('[data-hero-cinematic]', function (root) {
        return carousel(root, { defaultDelay: 6000 });
    });
    each('[data-hero-frosted]', function (root) {
        return carousel(root, { defaultDelay: 5500 });
    });
}

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*-------------------------------------------*\
   index.js

   1.0 Declaration of constants
   - body
   - doc
   - win
   - root
   - pageWrapper
   - pageLoader
   - navigation
   - navigationMobile
   - sizes
   - wow

   1.1 Handler for changing scroll position and screen size
   - resize handler
   - scroll handler

   1.2 Declaration of general functions
   - Alert Messages
   - Jquery Video Modal
   - Likes Toggle
   - Hide Page Loader
   - Sticky Sidebar
   - Hide Page Loader
   - Scroll Top Button
   - Page Progress Bar
   - Particles
   - Isotope Grid
   - Tilt Init
   - Social Links Label
   - Navigation Language Toggle
   - Counters
   - Typed Text
   - Progress Bars
   - Accordion
   - Magnific Popup
   - Google Map Init
   - Navigation Validate
   - Grid Fixed Height

   1.3 Create of general classes
   - Hero Slider Shape [Interface]
   - Hero Slider Full Width [Interface]
   - Hero Slider Multiple [Interface]
   - Hero Slider Parallax [Interface]
   - Hero Slider Carousel [Interface]
   - Hero Scene Image Hover Gallery [Interface]
   - Testimonials Slider type 1 [Interface]
   - Testimonials Slider type 2 [Interface]
   - Testimonials Slider type 3 [Interface]
   - Testimonials Slider type 4 [Interface]
   - Team Slider type 1 [Interface]
   - Team Slider type 2 [Interface]
   - Posts Slider type 1 [Interface]
   - Posts Slider type 2 [Interface]
   - Posts Slider type 3 [Interface]
   - Posts Slider type 4 [Interface]
   - Navigation type 1 [Interface]
   - Navigation type 2 [Interface]
   - Navigation type 3 [Interface]
   - Navigation type mobile [Interface]
   - Tabs [Interface]

   1.4 Create of general interfaces

   1.5 Initializing of general functions / classes
   - before page loading
   - after page loading
\*-------------------------------------------*/
jQuery(document).ready(function ($) {
    'use strict';

    /* 1.0 Declaration of constants */

    // - body

    var body = $('body');

    // - doc
    var doc = $(document);

    // - win
    var win = $(window);

    // - root
    var root = document.querySelector(':root');

    // - pageWrapper
    var pageWrapper = $('.page-wrapper');

    // - pageLoader
    var pageLoader = $('.page-loader');

    // - navigation
    var navigation = $('.navigation');

    // - navigationMobile
    var navigationMobile = $('.navigation-mobile');

    // - sizes
    var sizes = {
        w: $(window).innerWidth(),
        h: $(window).innerHeight(),
        offsetY: win.pageYOffset
    };

    /* 1.1 Handler for changing scroll position and screen size */

    // - resize handler
    win.resize(function () {
        sizes.w = win.innerWidth();
        sizes.h = win.innerHeight();
    });

    // - scroll handler
    win.scroll(function () {
        sizes.offsetY = win.pageYOffset;
    });

    /* 1.2 Declaration of general functions */

    /* - Alert Messages
    *
    * Includes a message alert click handler that deletes the message
    * and creates a hide animation
    *
    *  */
    var alertMessagesInit = function alertMessagesInit() {
        $('.alert-message').find('.close-btn').on('click', function () {
            var target = $(this).parent();
            target.addClass('d-none');
            // TweenMax.to(target, 0.5, {
            //     opacity: 0,
            //     pointerEvents: 'none',
            //     transform: 'scale(1.05)',
            //     ease: Expo.easeInOut,
            //     onComplete: () => {
            //         target.addClass('d-none');
            //         // target.remove();
            //     }
            // })
        });
    };

    /* - Jquery Video Modal
    *
    * Includes a handler for videos that are called when you click
    * on the video toggle
    *
    *  */
    var modalVideoInit = function modalVideoInit() {
        $(".js-modal-btn").modalVideo();
    };

    /* - Hide Page Loader
    *
    * Includes a handler for hiding the page loader after all the
    * content on the page is completely ready
    *
    *  */
    var pageLoaderHideInit = function pageLoaderHideInit() {
        var loaderInner = pageLoader.find('.loader-inner-wrapper');
        TweenMax.to(loaderInner, 0.4, {
            opacity: 0,
            transform: 'translateY(-50px)',
            pointerEvents: 'none',
            ease: Power3.easeInOut,
            onComplete: function onComplete() {
                pageLoader.addClass('loader-hide');
            }
        });
    };

    /* - Sticky Sidebar
     *
     * Includes initialization of a sticky sidebar
     *
     *  */
    var stickySidebarInit = function stickySidebarInit() {
        if (sizes.w > 1024) {
            var sidebar = $('.sidebar-sticky').stickySidebar({
                topSpacing: 50,
                bottomSpacing: 50,
                containerSelector: '.content-sticky'
            });
        }
    };

    /* - Scroll Top Button
    *
    * Includes a handler for the appearance of the scroll button up,
    * as well as a click handler for this button, which creates a
    * smooth scroll animation
    *
    *  */
    var scrollTopButtonInit = function scrollTopButtonInit() {
        var scrollTopButton = $('.page-scroll-button-wrapper .scroll-button-top'),
            scrollTrigger = true,
            showAnimation = function showAnimation() {
            TweenMax.to(scrollTopButton, 0.3, {
                transform: 'translateY(0)',
                opacity: 1,
                pointerEvents: 'auto',
                ease: Power2.easeInOut
            }).play();
        },
            hideAnimation = function hideAnimation() {
            TweenMax.to(scrollTopButton, 0.3, {
                transform: 'translateY(25px)',
                opacity: 0,
                pointerEvents: 'none',
                ease: Power2.easeInOut
            }).play();
        };
        win.on('scroll', function () {
            if (win.scrollTop() > doc.height() / 3 && scrollTrigger) {
                showAnimation();
                scrollTrigger = false;
            }
            if (win.scrollTop() <= doc.height() / 3 && !scrollTrigger) {
                hideAnimation();
                scrollTrigger = true;
            }
        });
        scrollTopButton.on('click', function () {
            TweenMax.to(win, 1, {
                scrollTo: 0,
                ease: Power2.easeInOut
            }).play();
        });
    };

    /* - Page Progress Bar
    *
    * Includes a progress bar handler that is filled when the
    * page is scrolled
    *
    *  */
    var pageProgressBarInit = function pageProgressBarInit() {
        var progressBar = $('.progress-bar-page');
        if ($(progressBar).length) {
            var getMax = function getMax() {
                return doc.height() - $(window).height();
            };
            var getValue = function getValue() {
                return win.scrollTop();
            };
            var max = getMax(),
                value = void 0,
                width = void 0;
            var getWidth = function getWidth() {
                value = getValue();
                width = value / max * 100;
                width = width + '%';
                return width;
            };
            var setWidth = function setWidth() {
                progressBar.css({
                    width: getWidth()
                });
            };
            doc.on('scroll', setWidth);
            win.on('resize', function () {
                max = getMax();
                setWidth();
            });
        }
    };

    /* - Particles
    *
    * Includes a handler of particles, and a set of presets
    *
    *  */
    var particlesInit = function particlesInit() {
        var particlesBg = $('#particles-bg');
        if (particlesBg.hasClass('preset-1')) {
            var preset1 = {
                "particles": {
                    "number": {
                        "value": 200,
                        "density": {
                            "enable": false,
                            "value_area": 800
                        }
                    },
                    "color": {
                        "value": "#ffffff"
                    },
                    "shape": {
                        "type": "circle",
                        "stroke": {
                            "width": 0,
                            "color": "#000000"
                        }
                    },
                    "opacity": {
                        "value": 0.8,
                        "random": false,
                        "anim": {
                            "enable": false,
                            "speed": 1,
                            "opacity_min": 0.1,
                            "sync": false
                        }
                    },
                    "size": {
                        "value": 2,
                        "random": true,
                        "anim": {
                            "enable": false,
                            "speed": 1,
                            "size_min": 0.1,
                            "sync": false
                        }
                    },
                    "line_linked": {
                        "enable": false,
                        "distance": 150,
                        "color": "#ffffff",
                        "opacity": 0.4,
                        "width": 1
                    },
                    "move": {
                        "enable": true,
                        "speed": 1,
                        "direction": "none",
                        "random": false,
                        "straight": false,
                        "out_mode": "out",
                        "bounce": false,
                        "attract": {
                            "enable": false,
                            "rotateX": 600,
                            "rotateY": 1200
                        }
                    }
                },
                "interactivity": {
                    "detect_on": "canvas",
                    "events": {
                        "onhover": {
                            "enable": false,
                            "mode": "repulse"
                        },
                        "onclick": {
                            "enable": false,
                            "mode": "push"
                        },
                        "resize": true
                    },
                    "modes": {
                        "grab": {
                            "distance": 400,
                            "line_linked": {
                                "opacity": 1
                            }
                        },
                        "bubble": {
                            "distance": 400,
                            "size": 40,
                            "duration": 2,
                            "opacity": 8,
                            "speed": 3
                        },
                        "repulse": {
                            "distance": 200,
                            "duration": 0.4
                        },
                        "push": {
                            "particles_nb": 4
                        },
                        "remove": {
                            "particles_nb": 2
                        }
                    }
                },
                "retina_detect": true
            };
            particlesJS('particles-bg', preset1);
        } else if (particlesBg.hasClass('preset-2')) {
            var preset2 = {
                "particles": {
                    "number": {
                        "value": 150,
                        "density": {
                            "enable": false,
                            "value_area": 800
                        }
                    },
                    "color": {
                        "value": "#ffffff"
                    },
                    "shape": {
                        "type": "circle",
                        "stroke": {
                            "width": 1,
                            "color": "#ffffff"
                        },
                        "square": {
                            "nb_sides": 2
                        },
                        "image": {
                            "src": "img/github.svg",
                            "width": 100,
                            "height": 100
                        }
                    },
                    "opacity": {
                        "value": 0.3,
                        "random": false,
                        "anim": {
                            "enable": false,
                            "speed": 1,
                            "opacity_min": 0.1,
                            "sync": false
                        }
                    },
                    "size": {
                        "value": 2,
                        "random": true,
                        "anim": {
                            "enable": false,
                            "speed": 40,
                            "size_min": 0.1,
                            "sync": false
                        }
                    },
                    "line_linked": {
                        "enable": true,
                        "distance": 120,
                        "color": "#ffffff",
                        "opacity": 0.3,
                        "width": 1
                    },
                    "move": {
                        "enable": true,
                        "speed": 2,
                        "direction": "none",
                        "random": false,
                        "straight": false,
                        "out_mode": "out",
                        "bounce": false,
                        "attract": {
                            "enable": false,
                            "rotateX": 600,
                            "rotateY": 1200
                        }
                    }
                },
                "interactivity": {
                    "detect_on": "canvas",
                    "events": {
                        "onhover": {
                            "enable": false,
                            "mode": "grab"
                        },
                        "onclick": {
                            "enable": false,
                            "mode": "push"
                        },
                        "resize": true
                    },
                    "modes": {
                        "grab": {
                            "distance": 120,
                            "line_linked": {
                                "opacity": 1
                            }
                        },
                        "bubble": {
                            "distance": 400,
                            "size": 200,
                            "duration": 2,
                            "opacity": 8,
                            "speed": 3
                        },
                        "repulse": {
                            "distance": 200,
                            "duration": 0.4
                        },
                        "push": {
                            "particles_nb": 4
                        },
                        "remove": {
                            "particles_nb": 2
                        }
                    }
                },
                "retina_detect": true
            };
            particlesJS('particles-bg', preset2);
        } else if (particlesBg.hasClass('preset-3')) {
            var preset3 = {};
            particlesJS('particles-bg', preset3);
        } else if (particlesBg.hasClass('preset-4')) {} else if (particlesBg.hasClass('preset-5')) {} else if (particlesBg.hasClass('preset-6')) {}
    };

    /* - Isotope Grid
    *
    * Includes initialization of the grid isotope and groups
    * of buttons that filter the grid, there is also a grid item
    * counter
    *
    *  */
    var isotopeGridInit = function isotopeGridInit() {
        var isotopeGridWrapper = $('.isotope-grid-wrapper'),
            buttonsGridCounters = $('.buttons-group');
        $(isotopeGridWrapper).each(function () {
            var isotopeGrid = $(this).find('.isotope-grid'),
                buttonsGroup = $(this).find('.buttons-group'),
                buttons = buttonsGroup.find('button');
            isotopeGrid.isotope({
                itemSelector: '.grid-item',
                layoutMode: 'masonry'
            });
            buttonsGroup.on('click', 'button', function () {
                $(buttons).removeClass('active-button');
                $(this).addClass('active-button');
                var filter_value = $(this).attr('data-filter');
                isotopeGrid.isotope({
                    filter: filter_value
                });
            });
        });
        $(buttonsGridCounters).each(function () {
            var countAll = $(this).closest('.isotope-grid-wrapper').find('.grid-item').length;
            $($(this).find('button')).each(function () {
                if ($(this).data('filter') === '*') {
                    $(this).append('<span class="count-items">' + countAll + '</span>');
                } else {
                    $(this).append('<span class="count-items">' + $($(this).data('filter')).length + '</span>');
                }
            });
        });
    };

    window.isotopeGridInit = isotopeGridInit;

    /* - Tilt Init
    *
    * Includes a tilt effect initialization
    *
    *  */
    var tiltInit = function tiltInit() {
        var tiltWrapper = $('.tilt-wrapper');
        if ($(tiltWrapper).length) {
            $(tiltWrapper).each(function () {
                var $this = $(this);
                $this.tilt({
                    maxTilt: $this.data('tilt-value'),
                    perspective: $this.data('tilt-perspective'),
                    easing: "cubic-bezier(.03,.98,.52,.99)",
                    scale: $this.data('tilt-scale'),
                    speed: $this.data('tilt-speed'),
                    transition: true,
                    disableAxis: null,
                    reset: true,
                    maxGlare: 0.05
                });
            });
        }
    };

    /* - Navigation Language Toggle
    *
    * Includes a language switch handler that appears when you
    * hover over it
    *
    *  */
    var navigationLanguageToggleInit = function navigationLanguageToggleInit() {
        var languageToggle = $('.language-toggle');
        languageToggle.on('mouseenter', function () {
            TweenMax.to($(this).find('.sub-menu'), 0.25, {
                transform: 'translateY(0)',
                opacity: 1,
                pointerEvents: 'auto',
                ease: Elastic
            }).play();
        }).on('mouseleave', function () {
            TweenMax.to($(this).find('.sub-menu'), 0.25, {
                transform: 'translateY(10px)',
                opacity: 0,
                pointerEvents: 'none',
                ease: Elastic
            }).play();
        });
    };

    /* - Typed Text
    *
    * Includes a typed text handler that contains a set of data
    * attributes that are printed and changed one after another
    *
    *  */
    var typedTextInit = function typedTextInit() {
        var fancyText = $('.typed-text');
        fancyText.each(function () {
            var typed = new Typed($(fancyText).get($(this).index()), {
                strings: [$(this).data('type-word-1'), $(this).data('type-word-2'), $(this).data('type-word-3')],
                typeSpeed: $(this).data('type-speed'),
                backSpeed: $(this).data('back-speed'),
                loop: true
            });
        });
    };

    /* - Accordion
    *
    * Includes an accordion handler that opens on click
    *
    *  */
    var accordionInit = function accordionInit() {
        var accordions = $('.accordion');

        $(accordions).each(function () {
            var accordionItem = $(this).find('.accordion-item'),
                accordionHeader = $(accordionItem).find('.item-header'),
                openItem = function openItem(item) {
                TweenMax.to(item, 0.5, {
                    minHeight: item.find('.body-content').outerHeight(true) + 'px',
                    opacity: 1,
                    ease: Power3.ease
                });
            },
                closeItem = function closeItem(item) {
                TweenMax.to(item, 0.5, {
                    minHeight: 0,
                    height: 0,
                    opacity: 0,
                    ease: Power3.ease
                });
            };

            accordionHeader.on('click', function () {
                closeItem($(accordionHeader).not($(this)).parent().find('.item-body'));
                openItem($(this).parent().find('.item-body'));
                accordionItem.removeClass('accordion-arrow-active');
                $(this).parent().addClass('accordion-arrow-active');
            });
        });
    };

    /* - Navigation Validate
    *
    * Includes a handler for different types of navigation.
    * Handler creates padding from the top of page depending
    * on the height of the navigation bar
    *
    *  */
    var navigationValidateInit = function navigationValidateInit() {
        root.style.setProperty('--navigation-mobile-offset', '100px');
        if (navigation.hasClass('navigation-type-1')) {
            root.style.setProperty('--navigation-offset', '100px');
        } else if (navigation.hasClass('navigation-type-2')) {
            root.style.setProperty('--navigation-offset', '100px');
        } else if (navigation.hasClass('navigation-type-3')) {
            root.style.setProperty('--navigation-offset', '100px');
        }
    };

    /* - Grid Fixed Height
    *
    * Includes a grid item handler that makes their height equal
    * to the width, creating squares
    *
    *  */
    var gridFixHeightInit = function gridFixHeightInit() {
        var grid = $('.grid-fix-height');
        if (grid.length) {
            var items = grid.find('.grid-item'),
                itemSize = function itemSize() {
                items.css('height', items.outerWidth() + 'px');
            };
            itemSize();
            win.resize(function () {
                itemSize();
            });
        }
    };

    /* 1.3 Declaration of general classes */

    // - Hero Slider Shape [Interface]

    var HERO_SLIDER_SHAPE = function () {
        function HERO_SLIDER_SHAPE() {
            _classCallCheck(this, HERO_SLIDER_SHAPE);

            this.slider = $('.hero-slider-shape');
            this.slide = this.slider.find('.slide');
            this.length = this.slide.length;
            this.counter = this.slider.find('.counter-slider');
            this.navigation = this.slider.find('.slider-navigation');
            this.upButton = this.navigation.find('.up-button');
            this.button = this.navigation.find('.button');
            this.downButton = this.slider.find('.down-button');
            this.current = this.counter.find('.current');
            this.max = this.counter.find('.max');
            this.divider = this.counter.find('.divider');
            this.pagination = this.counter.find('.pagination');
            this.partWidth = this.divider.outerWidth() / this.length;
            this.startWidth = this.partWidth;
        }

        _createClass(HERO_SLIDER_SHAPE, [{
            key: '_checkActive',
            value: function _checkActive() {
                this.button.removeClass('disable-button');
                if ($(this.slider).find('.active-slide').index() === 0) {
                    this.upButton.addClass('disable-button');
                }
                if ($(this.slider).find('.active-slide').index() + 1 === this.length) {
                    this.downButton.addClass('disable-button');
                }
            }
        }, {
            key: '_upAnimation',
            value: function _upAnimation() {
                var _this = this;

                TweenMax.to(this.slider.find('.active-slide'), 0.7, {
                    transform: 'translateY(100%)',
                    ease: Power3.easeInOut,
                    onStart: function onStart() {
                        _this.button.css('pointer-events', 'none');
                    },
                    onComplete: function onComplete() {
                        _this.button.css('pointer-events', 'auto');
                    }
                });
                TweenMax.to(this.slider.find('.active-slide').prev(), 0.7, {
                    transform: 'translateY(0)',
                    ease: Power3.easeInOut
                });
                $(this.slider).find('.active-slide').prev().addClass('active-slide');
                $(this.slider).find('.active-slide').next().removeClass('active-slide');
            }
        }, {
            key: '_downAnimation',
            value: function _downAnimation() {
                var _this2 = this;

                TweenMax.to(this.slider.find('.active-slide'), 0.7, {
                    transform: 'translateY(-100%)',
                    ease: Power3.easeInOut,
                    onStart: function onStart() {
                        _this2.button.css('pointer-events', 'none');
                    },
                    onComplete: function onComplete() {
                        _this2.button.css('pointer-events', 'auto');
                    }
                });
                TweenMax.to(this.slider.find('.active-slide').next(), 0.7, {
                    transform: 'translateY(0)',
                    ease: Power3.easeInOut
                });
                $(this.slider).find('.active-slide').next().addClass('active-slide');
                $(this.slider).find('.active-slide').prev().removeClass('active-slide');
            }
        }, {
            key: '_handler',
            value: function _handler() {
                var _this3 = this;

                this.max.append(this.slide.length);
                this._checkActive();
                this.upButton.on('click', function () {
                    _this3._upAnimation();
                    _this3._checkActive();
                    _this3._set_counter();
                    _this3.startWidth -= _this3.partWidth;
                    _this3._progress(_this3.startWidth);
                });
                this.downButton.on('click', function () {
                    _this3._downAnimation();
                    _this3._checkActive();
                    _this3._set_counter();
                    _this3.startWidth += _this3.partWidth;
                    _this3._progress(_this3.startWidth);
                });
            }
        }, {
            key: '_set_counter',
            value: function _set_counter() {
                var _this4 = this;

                TweenMax.to(this.current, 0.15, {
                    opacity: 0.3,
                    transform: 'translateY(10px)',
                    ease: Expo.ease,
                    onComplete: function onComplete() {
                        TweenMax.to(_this4.current, 0.07, {
                            opacity: 1,
                            transform: 'translateY(0)',
                            ease: Expo.ease
                        });
                        _this4.current.text('');
                        _this4.current.append($(_this4.slider).find('.active-slide').index() + 1);
                    }
                });
            }
        }, {
            key: '_progress',
            value: function _progress(width) {
                TweenMax.to(this.pagination, 0.4, {
                    width: width + 'px',
                    ease: Expo.ease
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this.current.append($(this.slider).find('.active-slide').index() + 1);
                this._handler();
                this._progress(this.startWidth);
            }
        }]);

        return HERO_SLIDER_SHAPE;
    }();

    // - Hero Slider Full Width [Interface]


    var HERO_SLIDER_FULL_WIDTH = function () {
        function HERO_SLIDER_FULL_WIDTH() {
            _classCallCheck(this, HERO_SLIDER_FULL_WIDTH);

            this.slider = $('.hero-full-width-slider');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.hero-full-width-slider .swiper-container';
            this.swiperPagination = '.hero-full-width-slider .swiper-pagination';
            this.slideImage = this.slider.find('.background-image');
            this.slideImageInner = this.slideImage.find('.inner-image');
        }

        _createClass(HERO_SLIDER_FULL_WIDTH, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var _this5 = this;

                if (!this.slider.length) {
                    return;
                }
                var autoplaySpeed = parseInt(this.slider.data('autoplay-speed')) || 5000;
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 1,
                    speed: 600,
                    loop: this.slide.length > 1,
                    autoplay: {
                        delay: autoplaySpeed,
                        disableOnInteraction: false
                    },
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    }
                });
                swiper.on('slideChange', function () {
                    $('.active-image').removeClass('active-image');
                    $(_this5.slideImageInner[swiper.realIndex]).addClass('active-image');
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return HERO_SLIDER_FULL_WIDTH;
    }();

    // - Hero Slider Multiple [Interface]


    var HERO_SLIDER_MULTIPLE = function () {
        function HERO_SLIDER_MULTIPLE() {
            _classCallCheck(this, HERO_SLIDER_MULTIPLE);

            this.slider = $('.hero-slider-multiple');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.hero-slider-multiple .swiper-container';
            this.swiperNavigationNext = '.hero-slider-multiple .swiper-button-custom-next';
            this.swiperNavigationPrev = '.hero-slider-multiple .swiper-button-custom-prev';
        }

        _createClass(HERO_SLIDER_MULTIPLE, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 5,
                    speed: 300,
                    spaceBetween: 30,
                    loop: true,
                    grabCursor: true,
                    breakpoints: {
                        1600: {
                            slidesPerView: 4
                        },
                        1200: {
                            slidesPerView: 3
                        },
                        1024: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 1
                        }
                    },
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return HERO_SLIDER_MULTIPLE;
    }();

    // - Hero Slider Parallax [Interface]


    var HERO_SLIDER_PARALLAX = function () {
        function HERO_SLIDER_PARALLAX() {
            _classCallCheck(this, HERO_SLIDER_PARALLAX);

            this.slider = $('.hero-slider-parallax');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.hero-slider-parallax .swiper-container';
            this.swiperNavigationNext = '.hero-slider-parallax .swiper-button-custom-next';
            this.swiperNavigationPrev = '.hero-slider-parallax .swiper-button-custom-prev';
            this.swiperPagination = '.hero-slider-parallax .swiper-pagination-count';
        }

        _createClass(HERO_SLIDER_PARALLAX, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 1,
                    speed: 600,
                    direction: 'vertical',
                    loop: true,
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        type: 'fraction'
                    },
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return HERO_SLIDER_PARALLAX;
    }();

    // - Hero Slider Carousel [Interface]


    var HERO_SPLIT_CAROUSEL = function () {
        function HERO_SPLIT_CAROUSEL() {
            _classCallCheck(this, HERO_SPLIT_CAROUSEL);

            this.carousel = $('.hero-split-carousel');
            this.slide = this.carousel.find('.slide');
            this.navigation = this.carousel.find('.carousel-navigation');
            this.scrollButton = this.navigation.find('.scroll-button');
            this.scrollUpButton = this.navigation.find('.scroll-up');
            this.scrollDownButton = this.navigation.find('.scroll-down');
            this.length = this.slide.length;
        }

        _createClass(HERO_SPLIT_CAROUSEL, [{
            key: '_checkActive',
            value: function _checkActive() {
                this.scrollButton.removeClass('disable-button');
                if ($(this.carousel).find('.active-slide').index() === 0) {
                    this.scrollUpButton.addClass('disable-button');
                }
                if ($(this.carousel).find('.active-slide').index() + 1 === this.length) {
                    this.scrollDownButton.addClass('disable-button');
                }
            }
        }, {
            key: '_scrollUpAnimation',
            value: function _scrollUpAnimation() {
                var _this6 = this;

                var transformValues = new Array(2),
                    resize = function resize() {
                    if (sizes.w >= 1025) {
                        transformValues[0] = 'translateY(100%)';
                        transformValues[1] = 'translateY(0)';
                    } else {
                        transformValues[0] = 'translateX(100%)';
                        transformValues[1] = 'translateX(0)';
                    }
                };
                resize();
                win.resize(function () {
                    resize();
                });
                TweenMax.staggerTo($(this.carousel).find('.active-slide').children(), 0.8, {
                    transform: transformValues[0],
                    ease: Power3.easeInOut,
                    onStart: function onStart() {
                        _this6.scrollButton.css('pointer-events', 'none');
                    },
                    onComplete: function onComplete() {
                        _this6.scrollButton.css('pointer-events', 'auto');
                    }
                }, 0.04);
                TweenMax.staggerTo($(this.carousel).find('.active-slide').prev().children(), 0.8, {
                    transform: transformValues[1],
                    ease: Power3.easeInOut
                }, 0.04);
                $(this.carousel).find('.active-slide').prev().addClass('active-slide');
                $(this.carousel).find('.active-slide').next().removeClass('active-slide');
                this._checkActive();
            }
        }, {
            key: '_scrollDownAnimation',
            value: function _scrollDownAnimation() {
                var _this7 = this;

                var transformValues = new Array(2),
                    resize = function resize() {
                    if (sizes.w >= 1025) {
                        transformValues[0] = 'translateY(-100%)';
                        transformValues[1] = 'translateY(0)';
                    } else {
                        transformValues[0] = 'translateX(-100%)';
                        transformValues[1] = 'translateX(0)';
                    }
                };
                resize();
                win.resize(function () {
                    resize();
                });
                TweenMax.staggerTo($(this.carousel).find('.active-slide').children(), 0.8, {
                    transform: transformValues[0],
                    ease: Power3.easeInOut,
                    onStart: function onStart() {
                        _this7.scrollButton.css('pointer-events', 'none');
                    },
                    onComplete: function onComplete() {
                        _this7.scrollButton.css('pointer-events', 'auto');
                    }
                }, 0.04);
                TweenMax.staggerTo($(this.carousel).find('.active-slide').next().children(), 0.8, {
                    transform: transformValues[1],
                    ease: Power3.easeInOut
                }, 0.04);
                $(this.carousel).find('.active-slide').next().addClass('active-slide');
                $(this.carousel).find('.active-slide').prev().removeClass('active-slide');
                this._checkActive();
            }
        }, {
            key: '_carouselHandler',
            value: function _carouselHandler() {
                var _this8 = this;

                $(this.slide[0]).addClass('active-slide');
                this._checkActive();
                this.scrollDownButton.on('click', function () {
                    _this8._scrollDownAnimation();
                });
                this.scrollUpButton.on('click', function () {
                    _this8._scrollUpAnimation();
                });
                var tabletTrigger = false,
                    computerTrigger = false;
                if (sizes.w >= 1025) {
                    computerTrigger = true;
                } else {
                    tabletTrigger = true;
                }
                var resize = function resize() {
                    if (sizes.w >= 1025 && tabletTrigger) {
                        for (var i = 0; i < $(_this8.carousel).find('.active-slide').index(); i++) {
                            TweenMax.staggerTo($(_this8.slide[i]).children(), 0, {
                                transform: 'translateY(-100%) translateX(0)'
                            }, 0);
                        }
                        tabletTrigger = false;
                        computerTrigger = true;
                    }
                    if (sizes.w < 1025 && computerTrigger) {
                        for (var _i = 0; _i < $(_this8.carousel).find('.active-slide').index(); _i++) {
                            TweenMax.staggerTo($(_this8.slide[_i]).children(), 0, {
                                transform: 'translateY(0) translateX(-100%)'
                            }, 0);
                        }
                        computerTrigger = false;
                        tabletTrigger = true;
                    }
                };
                win.resize(function () {
                    resize();
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._carouselHandler();
            }
        }]);

        return HERO_SPLIT_CAROUSEL;
    }();

    // - Hero Scene Image Hover Gallery [Interface]


    var HERO_SCENE_IMAGE_HOVER_GALLERY = function () {
        function HERO_SCENE_IMAGE_HOVER_GALLERY() {
            _classCallCheck(this, HERO_SCENE_IMAGE_HOVER_GALLERY);

            this.scene = $('.hero-image-hover-gallery');
            this.sceneImage = this.scene.find('.image-wrapper');
            this.sceneImageInner = this.sceneImage.find('.inner-image');
            this.imagesLinks = this.scene.find('.images-links').children();
        }

        _createClass(HERO_SCENE_IMAGE_HOVER_GALLERY, [{
            key: '_imageHover',
            value: function _imageHover() {
                var images = this.sceneImageInner,
                    links = this.imagesLinks,
                    timer = void 0;
                links.children().on('mouseenter', function () {
                    var index = $(this).parent().index();
                    links.not($(this).parent()).addClass('disable-link');
                    timer = setTimeout(function () {
                        images.not($(images[index])).removeClass('active-image');
                        $(images[index]).addClass('active-image');
                    }, 500);
                }).on('mouseleave', function () {
                    links.removeClass('disable-link');
                    clearTimeout(timer);
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._imageHover();
            }
        }]);

        return HERO_SCENE_IMAGE_HOVER_GALLERY;
    }();

    // - Testimonials Slider type 1 [Interface]


    var TESTIMONIALS_SLIDER_1 = function () {
        function TESTIMONIALS_SLIDER_1() {
            _classCallCheck(this, TESTIMONIALS_SLIDER_1);

            this.slider = $('.testimonials-slider-type-1');
            this.slidesWrapper = this.slider.find('.slides-wrapper');
            this.slide = this.slider.find('.slide');
            this.length = this.slide.length;
            this.navigation = this.slider.find('.slider-navigation');
            this.button = this.navigation.find('.slider-button');
            this.buttonUp = this.navigation.find('.slider-button-up');
            this.buttonDown = this.navigation.find('.slider-button-down');
            this.slideIndex = 1;
        }

        _createClass(TESTIMONIALS_SLIDER_1, [{
            key: '_rescale',
            value: function _rescale(index) {
                this.button.removeClass('disable-button');
                TweenMax.to($(this.slide).not($(this.slide[index])), 0.6, {
                    transform: 'scale(0.9)',
                    className: '-=active-slide',
                    pointerEvents: 'none',
                    opacity: 0.6,
                    ease: Power3.easeInOut
                });
                TweenMax.to($(this.slide[index]), 0.6, {
                    transform: 'scale(1)',
                    className: '+=active-slide',
                    pointerEvents: 'auto',
                    opacity: 1,
                    ease: Power3.easeInOut
                });
            }
        }, {
            key: '_downAnimation',
            value: function _downAnimation() {
                var _this9 = this;

                this.button.css('pointer-events', 'none');
                TweenMax.to(this.slidesWrapper, 0.6, {
                    y: '-=265',
                    ease: Power3.easeInOut,
                    onComplete: function onComplete() {
                        _this9.button.css('pointer-events', 'auto');
                    }
                });
                this.slideIndex++;
                this._rescale(this.slideIndex);
                if (this.slideIndex === this.length - 1) {
                    this.buttonDown.addClass('disable-button');
                }
            }
        }, {
            key: '_upAnimation',
            value: function _upAnimation() {
                var _this10 = this;

                this.button.css('pointer-events', 'none');
                TweenMax.to(this.slidesWrapper, 0.6, {
                    y: '+=265',
                    ease: Power3.easeInOut,
                    onComplete: function onComplete() {
                        _this10.button.css('pointer-events', 'auto');
                    }
                });
                this.slideIndex--;
                this._rescale(this.slideIndex);
                if (this.slideIndex === 0) {
                    this.buttonUp.addClass('disable-button');
                }
            }
        }, {
            key: '_handler',
            value: function _handler() {
                var _this11 = this;

                this.buttonUp.on('click', function () {
                    if (_this11.slideIndex > 0) {
                        _this11._upAnimation();
                    }
                });
                this.buttonDown.on('click', function () {
                    if (_this11.slideIndex < _this11.length - 1) {
                        _this11._downAnimation();
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._rescale(this.slideIndex);
                this._handler();
            }
        }]);

        return TESTIMONIALS_SLIDER_1;
    }();

    // - Testimonials Slider type 2 [Interface]


    var TESTIMONIALS_SLIDER_2 = function () {
        function TESTIMONIALS_SLIDER_2() {
            _classCallCheck(this, TESTIMONIALS_SLIDER_2);

            this.slider = $('.testimonials-slider-type-2');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.testimonials-slider-type-2 .swiper-container';
            this.swiperNavigationNext = '.testimonials-slider-type-2 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.testimonials-slider-type-2 .swiper-button-custom-prev';
            this.swiperPagination = '.testimonials-slider-type-2 .swiper-pagination';
        }

        _createClass(TESTIMONIALS_SLIDER_2, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    speed: 600,
                    loop: false,
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    },
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 1
                        }
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return TESTIMONIALS_SLIDER_2;
    }();

    // - Testimonials Slider type 3 [Interface]


    var TESTIMONIALS_SLIDER_3 = function () {
        function TESTIMONIALS_SLIDER_3() {
            _classCallCheck(this, TESTIMONIALS_SLIDER_3);

            this.slider = $('.testimonials-slider-type-3');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.testimonials-slider-type-3 .swiper-container';
            this.swiperPagination = '.testimonials-slider-type-3 .swiper-pagination';
            this.swiperNavigationNext = '.testimonials-slider-type-3 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.testimonials-slider-type-3 .swiper-button-custom-prev';
        }

        _createClass(TESTIMONIALS_SLIDER_3, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    speed: 500,
                    loop: true,
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    },
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    },
                    breakpoints: {
                        1200: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 1
                        }
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return TESTIMONIALS_SLIDER_3;
    }();

    // - Testimonials Slider type 4 [Interface]


    var TESTIMONIALS_SLIDER_4 = function () {
        function TESTIMONIALS_SLIDER_4() {
            _classCallCheck(this, TESTIMONIALS_SLIDER_4);

            this.slider = $('.testimonials-slider-type-4');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.testimonials-slider-type-4 .swiper-container';
            this.swiperNavigationNext = '.testimonials-slider-type-4 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.testimonials-slider-type-4 .swiper-button-custom-prev';
            this.swiperPagination = '.testimonials-slider-type-4 .swiper-pagination-count';
        }

        _createClass(TESTIMONIALS_SLIDER_4, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    centeredSlides: true,
                    slidesPerView: 1,
                    speed: 250,
                    loop: true,
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        type: 'fraction'
                    },
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return TESTIMONIALS_SLIDER_4;
    }();

    // - Team Slider type 1 [Interface]


    var TEAM_SLIDER_1 = function () {
        function TEAM_SLIDER_1() {
            _classCallCheck(this, TEAM_SLIDER_1);

            this.slider = $('.team-member-slider-type-1');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.team-member-slider-type-1 .swiper-container';
            this.swiperPagination = '.team-member-slider-type-1 .swiper-pagination';
            this.swiperNavigationNext = '.team-member-slider-type-1 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.team-member-slider-type-1 .swiper-button-custom-prev';
        }

        _createClass(TEAM_SLIDER_1, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    speed: 200,
                    loop: true,
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    },
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    },
                    breakpoints: {
                        1440: {
                            slidesPerView: 3
                        },
                        1024: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 1
                        }
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return TEAM_SLIDER_1;
    }();

    // - Team Slider type 2 [Interface]


    var TEAM_SLIDER_2 = function () {
        function TEAM_SLIDER_2() {
            _classCallCheck(this, TEAM_SLIDER_2);

            this.slider = $('.team-member-slider-type-2');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.team-member-slider-type-2 .swiper-container';
            this.swiperPagination = '.team-member-slider-type-2 .swiper-pagination';
            this.swiperNavigationNext = '.team-member-slider-type-2 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.team-member-slider-type-2 .swiper-button-custom-prev';
        }

        _createClass(TEAM_SLIDER_2, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 3,
                    spaceBetween: 30,
                    speed: 400,
                    loop: true,
                    grabCursor: true,
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    },
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    },
                    breakpoints: {
                        1024: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 1
                        }
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return TEAM_SLIDER_2;
    }();

    // - Posts Slider type 1 [Interface]


    var POSTS_SLIDER_TYPE_1 = function () {
        function POSTS_SLIDER_TYPE_1() {
            _classCallCheck(this, POSTS_SLIDER_TYPE_1);

            this.slider = $('.posts-slider-type-1');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.posts-slider-type-1 .swiper-container';
            this.swiperPagination = '.posts-slider-type-1 .swiper-pagination';
            this.swiperNavigationNext = '.posts-slider-type-1 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.posts-slider-type-1 .swiper-button-custom-prev';
        }

        _createClass(POSTS_SLIDER_TYPE_1, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    slidesPerView: 4,
                    spaceBetween: 30,
                    speed: 250,
                    loop: true,
                    grabCursor: true,
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    },
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    },
                    breakpoints: {
                        1440: {
                            slidesPerView: 3
                        },
                        1024: {
                            slidesPerView: 2
                        },
                        768: {
                            slidesPerView: 1
                        }
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return POSTS_SLIDER_TYPE_1;
    }();

    // - Posts Slider type 2 [Interface]


    var POSTS_SLIDER_TYPE_2 = function () {
        function POSTS_SLIDER_TYPE_2() {
            _classCallCheck(this, POSTS_SLIDER_TYPE_2);

            this.slider = $('.posts-slider-type-2');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.posts-slider-type-2 .swiper-container';
            this.swiperPagination = '.posts-slider-type-2 .swiper-pagination';
            this.swiperNavigationNext = '.posts-slider-type-2 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.posts-slider-type-2 .swiper-button-custom-prev';
        }

        _createClass(POSTS_SLIDER_TYPE_2, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    speed: 500,
                    loop: true,
                    effect: 'fade',
                    grabCursor: true,
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    },
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return POSTS_SLIDER_TYPE_2;
    }();

    // - Posts Slider type 3 [Interface]


    var POSTS_SLIDER_TYPE_3 = function () {
        function POSTS_SLIDER_TYPE_3() {
            _classCallCheck(this, POSTS_SLIDER_TYPE_3);

            this.slider = $('.posts-slider-type-3');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.posts-slider-type-3 .swiper-container';
        }

        _createClass(POSTS_SLIDER_TYPE_3, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    speed: 300,
                    slidesPerView: 3,
                    spaceBetween: 30,
                    loop: true,
                    grabCursor: true,
                    breakpoints: {
                        1024: {
                            slidesPerView: 2
                        },
                        576: {
                            slidesPerView: 1
                        }
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return POSTS_SLIDER_TYPE_3;
    }();

    // - Posts Slider type 4 [Interface]


    var POSTS_SLIDER_TYPE_4 = function () {
        function POSTS_SLIDER_TYPE_4() {
            _classCallCheck(this, POSTS_SLIDER_TYPE_4);

            this.slider = $('.posts-slider-type-4');
            this.slide = this.slider.find('.swiper-slide');
            this.swiperContainer = '.posts-slider-type-4 .swiper-container';
            this.swiperPagination = '.posts-slider-type-4 .swiper-pagination';
            this.swiperNavigationNext = '.posts-slider-type-4 .swiper-button-custom-next';
            this.swiperNavigationPrev = '.posts-slider-type-4 .swiper-button-custom-prev';
        }

        _createClass(POSTS_SLIDER_TYPE_4, [{
            key: '_swiperSlider',
            value: function _swiperSlider() {
                var swiper = new Swiper(this.swiperContainer, {
                    speed: 300,
                    slidesPerView: 4,
                    spaceBetween: 30,
                    loop: true,
                    grabCursor: true,
                    navigation: {
                        nextEl: this.swiperNavigationNext,
                        prevEl: this.swiperNavigationPrev
                    },
                    pagination: {
                        el: this.swiperPagination,
                        clickable: true
                    },
                    breakpoints: {
                        1200: {
                            slidesPerView: 3
                        },
                        1024: {
                            slidesPerView: 2
                        },
                        576: {
                            slidesPerView: 1
                        }
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._swiperSlider();
            }
        }]);

        return POSTS_SLIDER_TYPE_4;
    }();

    // - Navigation type 1 [Interface]


    var NAVIGATION_TYPE_1 = function () {
        function NAVIGATION_TYPE_1() {
            _classCallCheck(this, NAVIGATION_TYPE_1);

            this.navigation = $('.navigation-type-1');
            this.navigationToggle = this.navigation.find('.menu-toggle-wrapper');
            this.navigationToggleClose = this.navigation.find('.menu-panel-close-wrapper');
            this.navigationPanel = this.navigation.find('.navigation-panel');
            this.menuList = this.navigation.find('.menu-list');
            this.menuItemHasChildren = this.navigation.find('.menu-item-has-children');
            this.menuItemCurrent = this.navigation.find('.current-menu-item');
            this.menuImage = this.navigation.find('.menu-image');
            this.menuList.children('.menu-item').addClass('menu-item-parent');
            this.menuParent = $('.menu-item-parent');
            this.subMenu = this.menuList.find('.sub-menu');
            this.searchToggle = this.navigation.find('.search-toggle');
            this.searchCloseToggle = this.navigation.find('.search-form-close');
            this.searchForm = this.navigation.find('.search-form');
        }

        _createClass(NAVIGATION_TYPE_1, [{
            key: '_subMenu',
            value: function _subMenu() {
                var animItems = function animItems(items) {
                    TweenMax.staggerTo(items, 0.35, {
                        transform: 'translateY(0)',
                        opacity: 1,
                        pointerEvents: 'auto',
                        ease: Power3.ease
                    }, 0.06);
                },
                    hideItems = function hideItems(items) {
                    TweenMax.staggerTo(items, 0.35, {
                        transform: 'translateY(-50px)',
                        opacity: 0,
                        pointerEvents: 'none',
                        ease: Power3.ease
                    }, 0.06);
                };
                $(this.menuList.children('.menu-item-has-children')).each(function () {
                    var childrenCount = $(this).find('.menu-item').length;
                    if (childrenCount > 0) {
                        $(this).children('a').append('<span class="children-count">' + childrenCount + '</span>');
                    }
                });
                this.menuParent.on('mouseenter', function () {
                    animItems($(this).find('.active-list').addClass('active-list-secondary').children('.menu-item').children('a'));
                }).on('mouseleave', function () {
                    $(this).closest('.menu-item-parent').find('.sub-menu').removeClass('active-list-secondary');
                    hideItems($(this).find('.active-list').children('.menu-item').children('a'));
                });
                this.menuItemHasChildren.children('a').addClass('menu-item-has-children-link');
                this.menuParent.children('.sub-menu').addClass('active-list').children('.menu-item-has-children').children('.sub-menu').prepend('<li class="menu-item menu-item-back"><a><i class="icofont-long-arrow-left"></i><span>' + this.navigation.find('.menu-list-wrapper').data('back-link') + '</span></a></li>');
                this.menuList.addClass('active-list');
                this.menuParent.find('.menu-item-has-children').children('a').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this),
                        activeList = $this.closest('.menu-item-parent').find('.active-list');
                    activeList.removeClass('active-list');
                    $this.parent().children('.sub-menu').addClass('active-list');
                    hideItems(activeList.children().children('a'));
                    animItems($this.closest('.menu-item-parent').find('.active-list').children().children('a'));
                });
                this.subMenu.find('.menu-item-back').children('a').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this),
                        activeList = $this.closest('.menu-item-parent').find('.active-list');
                    hideItems(activeList.children().children('a'));
                    activeList.removeClass('active-list');
                    $(this).closest('.sub-menu').parent().parent().addClass('active-list');
                    animItems($this.closest('.menu-item-parent').find('.active-list').children().children('a'));
                });
            }
        }, {
            key: '_menuItemImage',
            value: function _menuItemImage() {
                var menuImage = this.menuImage;
                $(this.menuParent).each(function () {
                    var currentImage = $(this).data('menu-image');
                    menuImage.append('<div class="slide" style="background-image: url(' + currentImage + ')"></div>');
                });
                var slides = menuImage.children('.slide'),
                    index = void 0,
                    oldIndex = void 0;
                if (this.menuItemCurrent.hasClass('menu-item-parent')) {
                    index = $(this.menuItemCurrent).index();
                } else {
                    index = $(this.menuItemCurrent).closest('.menu-item-parent').index();
                }
                $(slides[index]).addClass('active-slide');
                this.menuParent.on('mouseenter', function () {
                    if ($(this).index() !== index) {
                        index = $(this).index();
                        $(slides).removeClass('active-slide');
                        $(slides[index]).addClass('active-slide');
                    }
                }).on('mouseleave', function () {});
            }
        }, {
            key: '_menuAppear',
            value: function _menuAppear() {
                var _this12 = this;

                var animationHide = function animationHide() {
                    TweenMax.staggerTo($(_this12.menuParent.children('a')), 0.5, {
                        opacity: 0,
                        y: -30,
                        pointerEvents: 'none',
                        ease: Expo.easeInOut,
                        onStart: function onStart() {
                            $(_this12.menuParent.children('a')).css('transition', 'unset');
                        }
                    }, 0.06);
                    TweenMax.to($(_this12.menuImage), 0.8, {
                        transform: 'translateX(100%)',
                        ease: Expo.easeInOut
                    });
                    TweenMax.to($(_this12.menuImage), 0.8, {
                        transform: 'translateX(100%)',
                        ease: Expo.easeInOut
                    });
                    TweenMax.to($(_this12.navigationToggleClose), 0.8, {
                        opacity: 0,
                        transform: 'translateY(50px)',
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                },
                    animationShow = function animationShow() {
                    TweenMax.staggerTo($(_this12.menuParent.children('a')), 0.5, {
                        opacity: 1,
                        y: 0,
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    }, 0.06, function () {
                        $(_this12.menuParent.children('a')).css('transition', 'all .3s ease-in');
                    });
                    TweenMax.to($(_this12.menuImage), 0.8, {
                        transform: 'translateX(0)',
                        ease: Expo.easeInOut
                    });
                    TweenMax.to($(_this12.navigationToggleClose), 0.8, {
                        opacity: 1,
                        transform: 'translateY(0)',
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                };
                animationHide();
                this.navigationToggle.on('click', function () {
                    TweenMax.to(_this12.navigationPanel, 0.6, {
                        opacity: 1,
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                    animationShow();
                });
                this.navigationToggleClose.on('click', function () {
                    animationHide();
                    TweenMax.to(_this12.navigationPanel, 0.6, {
                        delay: 0.5,
                        opacity: 0,
                        pointerEvents: 'none',
                        ease: Expo.easeInOut
                    });
                });
            }
        }, {
            key: '_searchForm',
            value: function _searchForm() {
                var _this13 = this;

                this.searchToggle.on('click', function () {
                    TweenMax.to(_this13.searchForm, 0.6, {
                        transform: 'translateY(0)',
                        ease: Expo.easeInOut
                    }).play();
                });
                this.searchCloseToggle.on('click', function () {
                    TweenMax.to(_this13.searchForm, 0.6, {
                        transform: 'translateY(-100%)',
                        ease: Expo.easeInOut
                    }).play();
                });
                $(doc).keyup(function (e) {
                    if (e.key === "Escape") {
                        TweenMax.to(_this13.searchForm, 0.6, {
                            transform: 'translateY(-100%)',
                            ease: Expo.easeInOut
                        }).play();
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._subMenu();
                this._menuAppear();
                this._menuItemImage();
                this._searchForm();
            }
        }]);

        return NAVIGATION_TYPE_1;
    }();

    // - Navigation type 2 [Interface]


    var NAVIGATION_TYPE_2 = function () {
        function NAVIGATION_TYPE_2() {
            _classCallCheck(this, NAVIGATION_TYPE_2);

            this.navigation = $('.navigation-type-2');
            this.menuList = this.navigation.find('.menu-list');
            this.itemsHasChildren = this.navigation.find('.menu-item-has-children');
            this.itemsHasMegamenu = this.navigation.find('.menu-item-has-megamenu');
            this.searchToggle = this.navigation.find('.search-toggle');
            this.searchCloseToggle = this.navigation.find('.search-form-close');
            this.searchForm = this.navigation.find('.search-form');
        }

        _createClass(NAVIGATION_TYPE_2, [{
            key: '_subMenu',
            value: function _subMenu() {
                this.itemsHasChildren.children('a').addClass('menu-item-has-children-link');
                $(this.itemsHasMegamenu).each(function () {
                    var height = $(this).children('.sub-menu').outerHeight(true),
                        width = 100 / $(this).children('.sub-menu').children('.menu-item').length;
                    $(this).children('.sub-menu').children('.menu-item').css({
                        'width': width + '%',
                        'min-width': width + '%',
                        'height': height + 'px'
                    });
                });
                this.itemsHasChildren.on('mouseenter', function () {
                    var subMenu = $(this).children('.sub-menu');
                    TweenMax.to(subMenu, 0.25, {
                        transform: 'translateY(0)',
                        opacity: 1,
                        pointerEvents: 'auto',
                        className: "+=active-sub-menu",
                        ease: Elastic
                    }).play();
                }).on('mouseleave', function () {
                    var subMenu = $(this).children('.sub-menu');
                    TweenMax.to(subMenu, 0.25, {
                        transform: 'translateY(10px)',
                        opacity: 0,
                        pointerEvents: 'none',
                        className: "-=active-sub-menu",
                        ease: Elastic
                    }).play();
                });
            }
        }, {
            key: '_searchForm',
            value: function _searchForm() {
                var _this14 = this;

                this.searchToggle.on('click', function () {
                    TweenMax.to(_this14.searchForm, 0.6, {
                        transform: 'translateY(0)',
                        ease: Expo.easeInOut
                    }).play();
                });
                this.searchCloseToggle.on('click', function () {
                    TweenMax.to(_this14.searchForm, 0.6, {
                        transform: 'translateY(-100%)',
                        ease: Expo.easeInOut
                    }).play();
                });
                $(doc).keyup(function (e) {
                    if (e.key === "Escape") {
                        TweenMax.to(_this14.searchForm, 0.6, {
                            transform: 'translateY(-100%)',
                            ease: Expo.easeInOut
                        }).play();
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._subMenu();
                this._searchForm();
            }
        }]);

        return NAVIGATION_TYPE_2;
    }();

    // - Navigation type 3 [Interface]


    var NAVIGATION_TYPE_3 = function () {
        function NAVIGATION_TYPE_3() {
            _classCallCheck(this, NAVIGATION_TYPE_3);

            this.navigation = $('.navigation-type-3');
            this.navigationToggle = this.navigation.find('.menu-toggle-wrapper');
            this.navigationToggleClose = this.navigation.find('.menu-panel-close-wrapper');
            this.navigationPanel = this.navigation.find('.navigation-panel');
            this.menuList = this.navigation.find('.menu-list');
            this.menuItemHasChildren = this.navigation.find('.menu-item-has-children');
            this.menuItemCurrent = this.navigation.find('.current-menu-item');
            this.menuList.children('.menu-item').addClass('menu-item-parent');
            this.menuParent = this.menuList.find('.menu-item-parent');
            this.subMenu = this.menuList.find('.sub-menu');
            this.searchForm = this.navigation.find('.search-form');
            this.searchFormToggle = this.navigation.find('.search-toggle-wrapper');
            this.searchFormWrapper = this.searchForm.find('.form-wrapper');
            this.searchFormToggleClose = this.searchForm.find('.form-close-wrapper');
        }

        _createClass(NAVIGATION_TYPE_3, [{
            key: '_subMenu',
            value: function _subMenu() {
                this.menuItemHasChildren.children('a').addClass('menu-item-has-children-link');
                $(this.menuParent).each(function () {
                    $(this).children('a').append('<span class="menu-item-subtitle">' + $(this).data('menu-subtitle') + '</span>');
                });
                this.subMenu.prepend('<li class="menu-item menu-item-back"><a><i class="icofont-long-arrow-left"></i><span>' + this.navigation.find('.menu-list-wrapper').data('back-link') + '</span></a></li>');
                this.menuList.addClass('active-list');
                var navigation = this.navigation,
                    animItems = function animItems(items) {
                    TweenMax.staggerTo(items, 0.45, {
                        transform: 'translateY(0)',
                        opacity: 1,
                        pointerEvents: 'auto',
                        ease: Power3.easeInOut
                    }, 0.06);
                },
                    hideItems = function hideItems(items) {
                    TweenMax.staggerTo(items, 0.45, {
                        transform: 'translateY(-30px)',
                        opacity: 0,
                        pointerEvents: 'none',
                        ease: Power3.easeInOut
                    }, 0.06);
                };
                this.menuItemHasChildren.children('a').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this),
                        activeList = navigation.find('.active-list');
                    activeList.removeClass('active-list');
                    $this.parent().children('.sub-menu').addClass('active-list');
                    hideItems(activeList.children().children('a'));
                    animItems(navigation.find('.active-list').children().children('a'));
                });
                this.subMenu.find('.menu-item-back').children('a').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this),
                        activeList = navigation.find('.active-list');
                    hideItems(activeList.children().children('a'));
                    activeList.removeClass('active-list');
                    $(this).closest('.sub-menu').parent().parent().addClass('active-list');
                    animItems(navigation.find('.active-list').children().children('a'));
                });
            }
        }, {
            key: '_menuAppear',
            value: function _menuAppear() {
                var _this15 = this;

                var animationHide = function animationHide() {
                    _this15.menuList.removeClass('active-menu');
                    TweenMax.staggerTo($(_this15.navigation).find('.active-list').children().children('a'), 0.5, {
                        opacity: 0,
                        transform: 'translateY(-30px)',
                        pointerEvents: 'none',
                        ease: Power3.easeInOut
                    }, 0.06);
                    TweenMax.to($(_this15.navigationToggleClose), 0.8, {
                        opacity: 0,
                        transform: 'translateY(25px)',
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                },
                    animationShow = function animationShow() {
                    _this15.menuList.addClass('active-menu');
                    TweenMax.staggerTo($(_this15.navigation).find('.active-list').children().children('a'), 0.5, {
                        opacity: 1,
                        transform: 'translateY(0)',
                        pointerEvents: 'auto',
                        ease: Power3.easeInOut
                    }, 0.06);
                    TweenMax.to($(_this15.navigationToggleClose), 0.8, {
                        opacity: 1,
                        transform: 'translateY(0)',
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                };
                this.navigationToggle.on('click', function () {
                    TweenMax.to(_this15.navigationPanel, 0.6, {
                        opacity: 1,
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                    animationShow();
                });
                this.navigationToggleClose.on('click', function () {
                    animationHide();
                    TweenMax.to(_this15.navigationPanel, 0.6, {
                        delay: 0.5,
                        opacity: 0,
                        pointerEvents: 'none',
                        ease: Expo.easeInOut
                    });
                });
            }
        }, {
            key: '_searchForm',
            value: function _searchForm() {
                var _this16 = this;

                var animationHide = function animationHide() {
                    TweenMax.to($(_this16.searchFormToggleClose), 0.6, {
                        opacity: 0,
                        transform: 'translateY(25px)',
                        pointerEvents: 'none',
                        ease: Expo.easeInOut
                    });
                    TweenMax.to($(_this16.searchFormWrapper), 0.6, {
                        delay: 0.15,
                        opacity: 0,
                        transform: 'translateY(40px)',
                        pointerEvents: 'none',
                        ease: Expo.easeInOut
                    });
                },
                    animationShow = function animationShow() {
                    TweenMax.to($(_this16.searchFormToggleClose), 0.6, {
                        opacity: 1,
                        transform: 'translateY(0)',
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                    TweenMax.to($(_this16.searchFormWrapper), 0.6, {
                        delay: 0.15,
                        opacity: 1,
                        transform: 'translateY(0)',
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                };
                this.searchFormToggle.on('click', function () {
                    animationShow();
                    TweenMax.to(_this16.searchForm, 0.6, {
                        opacity: 1,
                        pointerEvents: 'auto',
                        ease: Expo.easeInOut
                    });
                });
                this.searchFormToggleClose.on('click', function () {
                    animationHide();
                    TweenMax.to(_this16.searchForm, 0.6, {
                        delay: 0.5,
                        opacity: 0,
                        pointerEvents: 'none',
                        ease: Expo.easeInOut
                    });
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._subMenu();
                this._menuAppear();
                // this._searchForm();
            }
        }]);

        return NAVIGATION_TYPE_3;
    }();

    // - Navigation type mobile [Interface]


    var NAV_TYPE_MOBILE = function () {
        function NAV_TYPE_MOBILE() {
            _classCallCheck(this, NAV_TYPE_MOBILE);

            this.navigation = navigationMobile;
            this.menuList = this.navigation.find('.menu-list');
            this.subMenus = this.navigation.find('.sub-menu');
            this.itemsHasChildren = this.navigation.find('.menu-item-has-children,.menu-item-object-category');
            this.toggle = this.navigation.find('.menu-toggle');
            this.toggleClose = this.navigation.find('.menu-toggle-close');
            this.menuPanel = this.navigation.find('.menu-list-wrapper');
            this.searchToggle = this.navigation.find('.search-form-toggle');
            this.searchCloseToggle = this.navigation.find('.search-form-close');
            this.searchFormWrapper = this.navigation.find('.search-form-wrapper');
        }

        _createClass(NAV_TYPE_MOBILE, [{
            key: '_searchForm',
            value: function _searchForm() {
                var _this17 = this;

                this.searchToggle.on('click', function () {
                    TweenMax.to(_this17.searchFormWrapper, 0.8, {
                        transform: 'translateY(0)',
                        ease: Expo.easeInOut
                    }).play();
                });
                this.searchCloseToggle.on('click', function () {
                    TweenMax.to(_this17.searchFormWrapper, 0.8, {
                        transform: 'translateY(-100%)',
                        ease: Expo.easeInOut
                    }).play();
                });
            }
        }, {
            key: '_subMenu',
            value: function _subMenu() {
                var _this18 = this;

                this.itemsHasChildren.children('a').addClass('menu-item-has-children-link');
                this.subMenus.prepend('<li class="menu-item menu-item-back"><a><i class="icofont-long-arrow-left"></i><span>' + this.navigation.find('.menu-list-wrapper').data('back-link') + '</span></a></li>');
                this.menuList.addClass('active-list');
                var navigation = this.navigation,
                    menuItemBack = navigation.find('.menu-item-back'),
                    animItems = function animItems(items) {
                    TweenMax.staggerTo(items, 0.4, {
                        transform: 'translateX(0)',
                        opacity: 1,
                        pointerEvents: 'auto',
                        ease: Power3.ease
                    }, 0.08);
                },
                    hideItems = function hideItems(items) {
                    TweenMax.staggerTo(items, 0.4, {
                        transform: 'translateX(-50px)',
                        opacity: 0,
                        pointerEvents: 'none',
                        ease: Power3.ease
                    }, 0.08);
                },
                    animPanel = TweenMax.to(this.menuPanel, 0.8, {
                    scale: 1,
                    opacity: 1,
                    pointerEvents: 'auto',
                    ease: Expo.easeInOut
                }).reverse();
                this.toggle.on('click', function () {
                    $(_this18.toggle).addClass('active-toggle');
                    animPanel.play();
                    TweenMax.to(body, 0, {
                        delay: 0.5,
                        onComplete: function onComplete() {
                            if (navigation.find('.active-list').hasClass('category-sub-menu')) {
                                animItems(navigation.find('.active-list').find('.post'));
                            } else {
                                animItems(navigation.find('.active-list').children().children('a'));
                            }
                        }
                    });
                });
                this.toggleClose.on('click', function () {
                    $(_this18.toggle).removeClass('active-toggle');
                    TweenMax.to(body, 0, {
                        delay: 0.3,
                        onComplete: function onComplete() {
                            animPanel.reverse();
                        }
                    });
                    if (navigation.find('.active-list').hasClass('category-sub-menu')) {
                        hideItems(navigation.find('.active-list').find('.post'));
                    } else {
                        hideItems(navigation.find('.active-list').children().children('a'));
                    }
                });
                this.itemsHasChildren.children('a').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    hideItems(navigation.find('.active-list').children().children('a'));
                    navigation.find('.active-list').removeClass('active-list');
                    $(this).parent().children('.sub-menu').addClass('active-list');
                    TweenMax.to(body, 0, {
                        delay: 0.3,
                        onComplete: function onComplete() {
                            animItems(navigation.find('.active-list').children().children('a'));
                        }
                    });
                });
                menuItemBack.children('a').on('click', function (e) {
                    e.preventDefault();
                    var $this = $(this);
                    hideItems(navigation.find('.active-list').children().children('a'));
                    navigation.find('.active-list').removeClass('active-list');
                    $(this).closest('.sub-menu').parent().parent().addClass('active-list');
                    TweenMax.to(body, 0, {
                        delay: 0.5,
                        onComplete: function onComplete() {
                            animItems(navigation.find('.active-list').children().children('a'));
                        }
                    });
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._subMenu();
                this._searchForm();
            }
        }]);

        return NAV_TYPE_MOBILE;
    }();

    // - Tabs [Interface]


    var TABS = function () {
        function TABS() {
            _classCallCheck(this, TABS);

            this.tabsWrapper = $('.tabs-wrapper');
        }

        _createClass(TABS, [{
            key: '_showContent',
            value: function _showContent(item, type, body) {
                if (type === 'animation-type-1') {
                    TweenMax.to(item, 1, {
                        opacity: 1,
                        transform: 'scale(1)',
                        ease: Expo.easeInOut
                    });
                } else if (type === 'animation-type-2') {
                    body.css('min-height', $(item).outerHeight(true) + 'px');
                    TweenMax.to(item, 0.75, {
                        opacity: 1,
                        ease: Expo.easeInOut
                    });
                } else if (type === 'animation-type-3') {} else if (type === 'animation-type-4') {}
            }
        }, {
            key: '_hideContent',
            value: function _hideContent(item, type) {
                if (type === 'animation-type-1') {
                    TweenMax.to(item, 1, {
                        opacity: 0,
                        transform: 'scale(1.1)',
                        ease: Expo.easeInOut
                    });
                } else if (type === 'animation-type-2') {
                    TweenMax.to(item, 0.75, {
                        opacity: 0,
                        ease: Expo.easeInOut
                    });
                } else if (type === 'animation-type-3') {} else if (type === 'animation-type-4') {}
            }
        }, {
            key: '_handler',
            value: function _handler() {
                var showContent = this._showContent,
                    hideContent = this._hideContent;
                $(this.tabsWrapper).each(function () {
                    var $this = $(this),
                        tabsItems = $this.find('.tab-item'),
                        tabBody = $this.find('.tab-body'),
                        tabContent = $this.find('.tab-content'),
                        tabHeader = $this.find('.tab-header'),
                        timer = void 0;
                    showContent($(tabContent[tabHeader.find('.active-item').index()]), $this.data('tab-animation-type'), tabBody);

                    if ($this.data('tab-handler-type') === 'hover') {
                        tabsItems.on('mouseenter', function () {
                            var _this19 = this;

                            timer = setTimeout(function () {
                                hideContent($(tabContent[tabHeader.find('.active-item').index()]), $this.data('tab-animation-type'));
                                tabsItems.removeClass('active-item');
                                $(_this19).addClass('active-item');
                                showContent($(tabContent[$(_this19).index()]), $this.data('tab-animation-type'));
                            }, 200);
                        }).on('mouseleave', function () {
                            clearTimeout(timer);
                        });
                    } else if ($this.data('tab-handler-type') === 'click') {
                        tabsItems.on('click', function () {
                            hideContent($(tabContent[tabHeader.find('.active-item').index()]), $this.data('tab-animation-type'));
                            tabsItems.removeClass('active-item');
                            $(this).addClass('active-item');
                            showContent($(tabContent[$(this).index()]), $this.data('tab-animation-type'), tabBody);
                        });
                    }
                });
            }
        }, {
            key: 'init',
            value: function init() {
                this._handler();
            }
        }]);

        return TABS;
    }();

    /* 1.4 Create of general interfaces */


    var hero_slider_shape = new HERO_SLIDER_SHAPE(),
        hero_slider_full_width = new HERO_SLIDER_FULL_WIDTH(),
        hero_slider_multiple = new HERO_SLIDER_MULTIPLE(),
        hero_slider_parallax = new HERO_SLIDER_PARALLAX(),
        hero_split_carousel = new HERO_SPLIT_CAROUSEL(),
        hero_scene_image_hover_gallery = new HERO_SCENE_IMAGE_HOVER_GALLERY(),
        testimonials_slider_1 = new TESTIMONIALS_SLIDER_1(),
        testimonials_slider_2 = new TESTIMONIALS_SLIDER_2(),
        testimonials_slider_3 = new TESTIMONIALS_SLIDER_3(),
        testimonials_slider_4 = new TESTIMONIALS_SLIDER_4(),
        team_slider_1 = new TEAM_SLIDER_1(),
        team_slider_2 = new TEAM_SLIDER_2(),
        posts_slider_1 = new POSTS_SLIDER_TYPE_1(),
        posts_slider_2 = new POSTS_SLIDER_TYPE_2(),
        posts_slider_3 = new POSTS_SLIDER_TYPE_3(),
        posts_slider_4 = new POSTS_SLIDER_TYPE_4(),
        navigation_1 = new NAVIGATION_TYPE_1(),
        navigation_2 = new NAVIGATION_TYPE_2(),
        navigation_3 = new NAVIGATION_TYPE_3(),
        navigation_mobile = new NAV_TYPE_MOBILE(),
        tabs = new TABS();

    /* 1.5 Initializing of general functions / classes */
    // - before page loading
    navigationValidateInit();
    gridFixHeightInit();

    // - after page loading
    // Same set of images `body.imagesLoaded()` would have collected, minus the
    // site-entry popup's: that markup is included on every page (see
    // `front.partial.popup`) and stays hidden until the modal opens, but the browser
    // still downloads it — gating the preloader hide and every init below on a heavy
    // popup image delayed the whole site's boot.
    var boot_images = body.find('img').not('.popup-module img');

    // `imagesLoaded` is the only thing that hides the preloader, so if it never
    // settles — an image that neither loads nor errors, or the plugin throwing —
    // the whole site stays behind an opaque white screen. `window.load` is a
    // second, independent trigger; whichever arrives first wins.
    var booted = false;
    var bootAfterImages = function bootAfterImages() {
        if (booted) {
            return;
        }
        booted = true;
        hero_slider_shape.init();
        hero_slider_full_width.init();
        hero_slider_multiple.init();
        hero_slider_parallax.init();
        hero_split_carousel.init();
        // testimonials_slider_1.init();
        testimonials_slider_2.init();
        // testimonials_slider_3.init();
        // testimonials_slider_4.init();
        // posts_slider_1.init();
        // posts_slider_2.init();
        // posts_slider_3.init();
        // posts_slider_4.init();
        // team_slider_1.init();
        // team_slider_2.init();
        // navigation_1.init();
        navigation_2.init();
        // navigation_3.init();
        navigation_mobile.init();
        tabs.init();
        hero_scene_image_hover_gallery.init();
        pageLoaderHideInit();
        alertMessagesInit();
        modalVideoInit();
        stickySidebarInit();
        scrollTopButtonInit();
        // pageProgressBarInit();
        // particlesInit();
        isotopeGridInit();
        tiltInit();
        navigationLanguageToggleInit();
        // typedTextInit();
        accordionInit();
    };

    boot_images.imagesLoaded({}, bootAfterImages);
    win.on('load', bootAfterImages);
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var membersWorks = function membersWorks() {
    var elements = $('.member-works');

    if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
            $(elements[i]).magnificPopup({
                delegate: '.work-item',
                type: 'image',
                closeOnContentClick: false,
                closeBtnInside: false,
                mainClass: 'mfp-with-zoom mfp-img-mobile',
                image: {
                    verticalFit: true,
                    titleSrc: function titleSrc(item) {
                        return item.el.attr('data-title') + '<br>' + item.el.attr('data-content');
                    }
                },
                gallery: {
                    enabled: true
                },
                zoom: {
                    enabled: true,
                    duration: 300, // don't foget to change the duration also in CSS
                    opener: function opener(element) {
                        return element.find('img');
                    }
                },
                callbacks: {
                    open: function open() {
                        $('html').css('margin-right', 0);
                        $('html').css('overflow', 'visible');
                    },
                    change: function change() {
                        var mfp = $.magnificPopup.instance;
                        var container = $(mfp.container);

                        if (mfp.index >= mfp.items.length - 1) container.addClass('mfp-last');else container.removeClass('mfp-last');
                        if (mfp.index == 0) container.addClass('mfp-first');else container.removeClass('mfp-first');
                    }
                }

            });
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (membersWorks);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preloader__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(1);



var profile = function profile() {
    // Update profile
    $('.profile-update-form').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        var data = form.serializeArray();

        var formData = new FormData();

        for (var key in data) {
            formData.append(data[key]['name'], data[key]['value']);
        }

        if (form.find('input[type="file"]').val()) {
            formData.append('image', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function success(response) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);
                form.find('.success-alert').removeClass('d-none');

                $('.user-name').html($('input[name="name"]').val());
            },
            error: function error(responseError) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* displayFormError */])(form, responseError);
            }
        });
    });

    // Update password
    $('.profile-update-password-form').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: form.serialize(),
            success: function success(response) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);
                form.trigger('reset');
                form.find('.success-alert').removeClass('d-none');
            },
            error: function error(responseError) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* displayFormError */])(form, responseError);
            }
        });
    });

    // TinyMce
    if (window.enableTinyMce !== undefined) {
        tinymce.init({
            menubar: false,
            selector: 'textarea.richTextBox',
            skin: 'voyager',
            min_height: 350,
            branding: false,
            resize: 'vertical',
            plugins: 'autolink, lists, link, image, paste, code, youtube, giphy, table, textcolor',
            extended_valid_elements: 'input[id|name|value|type|class|style|required|placeholder|autocomplete|onclick]',
            relative_urls: false,
            paste_data_images: true,
            toolbar: 'styleselect | bold italic underline | alignleft aligncenter alignright | bullist numlist outdent inden',
            style_formats: [{ title: 'Title', format: 'h4' }, { title: 'Text', block: 'p' }],
            setup: function setup(editor) {
                editor.on('change keyup', function () {
                    tinymce.triggerSave();
                });
            }
        });
    }

    // Update bio
    $('.profile-update-bio-form').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, true);

        form.find('.danger-alert').addClass('d-none');
        form.find('.success-alert').addClass('d-none');

        var data = form.serializeArray();

        var formData = new FormData();

        for (var key in data) {
            formData.append(data[key]['name'], data[key]['value']);
        }

        if (form.find('input[type="file"]').val()) {
            formData.append('file', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function success(response) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);

                form.find('.cv-path').attr('href', response.cv.path);
                form.find('.cv-name').html(response.cv.name);
                form.find('input[type="file"]').val('');
                form.find('.success-alert').removeClass('d-none');
            },
            error: function error(responseError) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* displayFormError */])(form, responseError);
            }
        });
    });

    // Work form-create Popup
    $('.open-popup-link').magnificPopup({
        type: 'inline',
        midClick: true
    });

    // Work form-edit Popup
    function workFormEditPopup() {
        $('.open-popup-link-edit').magnificPopup({
            type: 'inline',
            midClick: true,
            callbacks: {
                open: function open() {
                    // Get form and insert in popup container
                    $.get(this.st.el.data('url'), function (response) {
                        $('#work-edit-form-popup').html(response.view);
                        uploadImageEvent();
                    });
                },
                close: function close() {
                    // Clean popup container
                    $('#work-edit-form-popup').html('');
                }
            }
        });
    }

    workFormEditPopup();

    // Work store/update API
    $(document).on('submit', '.profile-save-work-form', function (e) {
        e.preventDefault();

        var form = $(this);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, true);

        form.find('.danger-alert').addClass('d-none');

        var data = form.serializeArray();

        var formData = new FormData();

        for (var key in data) {
            formData.append(data[key]['name'], data[key]['value']);
        }

        if (form.find('input[type="file"]').val()) {
            formData.append('image', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function success(response) {
                $('.member-works .isotope-grid-wrapper').html(response.view);

                setTimeout(function () {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);

                    form.find('input[type="file"]').val('');
                    window.isotopeGridInit();

                    workFormEditPopup();

                    $.magnificPopup.close();

                    form.find('#img-uploaded').attr('src', '/img/placeholder.jpg');
                    form.trigger('reset');
                }, 400);
            },
            error: function error(responseError) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* displayFormError */])(form, responseError);
            }
        });
    });

    // Work delete API
    $(document).on('click', '.delete-work', function (e) {
        e.preventDefault();
        if (confirm('Are you sure?')) {
            var form = $('.profile-save-work-form');

            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, true);

            $.ajax({
                url: $(this).data('url'),
                dataType: 'json',
                type: 'post',
                success: function success(response) {
                    $('.member-works .isotope-grid-wrapper').html(response.view);

                    setTimeout(function () {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);
                        window.isotopeGridInit();

                        workFormEditPopup();

                        $.magnificPopup.close();
                    }, 400);
                },
                error: function error(responseError) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* displayFormError */])(form, responseError);
                }
            });
        }
    });

    // Upload button
    var SITE = SITE || {};

    SITE.fileInputs = function () {
        var $this = $(this),
            $val = $this.val(),
            valArray = $val.split('\\'),
            newVal = valArray[valArray.length - 1],
            $button = $this.siblings('.btn'),
            $fakeFile = $this.siblings('.file-holder');
        if (newVal !== '') {
            $button.text('Photo Chosen');
            if ($fakeFile.length === 0) {
                $button.after('<span class="file-holder">' + newVal + '</span>');
            } else {
                $fakeFile.text(newVal);
            }
        }
    };

    $('.file-wrapper input[type=file]').bind('change focus click', SITE.fileInputs);

    function readURL(input) {
        if (input.files && input.files[0]) {
            var reader = new FileReader();
            var tmppath = URL.createObjectURL(input.files[0]);

            reader.onload = function (e) {
                $('#img-uploaded').attr('src', tmppath);
            };

            reader.readAsDataURL(input.files[0]);
        }
    }

    function uploadImageEvent() {
        $(".uploader").change(function () {
            readURL(this);
        });
    }

    uploadImageEvent();
};

/* harmony default export */ __webpack_exports__["a"] = (profile);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__preloader__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper__ = __webpack_require__(1);



var register = function register() {
    $('.register-form').on('submit', function (e) {
        e.preventDefault();

        var form = $(this);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, true);

        form.find('.danger-alert').addClass('d-none');

        var data = form.serializeArray();

        var formData = new FormData();

        for (var key in data) {
            formData.append(data[key]['name'], data[key]['value']);
        }

        if (form.find('input[type="file"]').val()) {
            formData.append('image', form.find('input[type="file"]')[0].files[0]);
        }

        $.ajax({
            url: form.attr('action'),
            dataType: 'json',
            type: 'post',
            data: formData,
            processData: false,
            contentType: false,
            success: function success(response) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__preloader__["a" /* default */])(form, false);

                if (response.errors) {
                    alert('Internal Error! Contact Administrator!');
                } else {

                    $('html, body').animate({
                        scrollTop: form.offset().top - 300
                    }, 300);

                    form.html('<h4 class="text-center">' + response.message + '</h4>');
                }
            },
            error: function error(responseError) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__helper__["a" /* displayFormError */])(form, responseError);
            }
        });
    });
};

/* harmony default export */ __webpack_exports__["a"] = (register);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__members__ = __webpack_require__(2);


var sections = function sections() {
    var elements = $('.sections-members');

    if (elements.length) {
        for (var i = 0; i < elements.length; i++) {
            var element = $(elements[i]);

            // Get first item and insert content to the main table
            // let firstTabHTML = $( element.find('.tab-item')[0]);
            //
            // element.find('.additional-info').html(firstTabHTML.html())
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__members__["b" /* tableActions */])(element, false, 1);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (sections);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var share = function share() {
    var popupSize = {
        width: 780,
        height: 550
    };

    $(document).on('click', '.social-button', function (e) {
        var verticalPos = Math.floor(($(window).width() - popupSize.width) / 2),
            horisontalPos = Math.floor(($(window).height() - popupSize.height) / 2);

        var popup = window.open($(this).prop('href'), 'social', 'width=' + popupSize.width + ',height=' + popupSize.height + ',left=' + verticalPos + ',top=' + horisontalPos + ',location=0,menubar=0,toolbar=0,status=0,scrollbars=1,resizable=1');

        if (popup) {
            popup.focus();
            e.preventDefault();
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = (share);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(3);
module.exports = __webpack_require__(4);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// /js/app.js